module.exports = __webpack_public_path__ + "img/Dataservices.9f9ea9e0.svg";